{
    "title": "Intermediary Institution Information",
    "titleaddress": "Intermediary Bank Address",
    "input":{
        "institutionname": "Intermediary Institution Name",
        "intermediarytype": "Intermediary Institution Location",
        "routingnumber": "Routing Number",
        "swiftbic": "Swift BIC",
        "addressline1": "Address Line 1",
        "addressline2": "Address Line 2",
        "addressline3": "Address Line 3",
        "state": "State",
        "city": "City",
        "postalcode": "Postal Code",
        "country": "Country",
        "unitnumber": "Unit Number"
    },
    "addaddress":"I want to add the Intermediary Bank address"
}